<div class="kpi-details-wrapper">
  <ng-container *ngIf="(isLoading$ | async) === false && (error$ | async) === null && kpi$ | async as kpi">
    <div class="body">
      <expandable-content class="description" *ngIf="kpi.description" [positionButtonsAbsolute]="true" [lineClamp]="3" data-test-id="kpi-details-description-field">
        {{ kpi.description }}
      </expandable-content>

      <div class="owners" [class.without-description]="!kpi.description" data-test-id="kpi-details-owners-field">
        <ui-assignee *ngIf="kpi.ownerIds.length === 1" [fromAssigneeId]="kpi.ownerIds[0]" uiSize="xs"></ui-assignee>
        <ui-assignee-avatar-group *ngIf="kpi.ownerIds.length > 1" [uiMax]="4" uiSize="xs">
          <ui-assignee-avatar *ngFor="let assigneeId of kpi.ownerIds" [fromAssigneeId]="assigneeId"></ui-assignee-avatar>
        </ui-assignee-avatar-group>
      </div>

      <div class="progress-and-actions">
        <kpi-progress></kpi-progress>

        <div class="actions" *ngIf="canEditKpi$ | async">
          <button *ngIf="!kpi.insightLink" (click)="openSnapshotFormModal()" data-test-id="kpi-details-update-kpi-button" ui-button uiType="default" uiShape="round">{{ "update" | localize }}</button>
          <button (click)="kpiChart.onClickSetProjectionButton()" data-test-id="kpi-details-set-projection-button" ui-button uiType="primary" uiShape="round">{{ "set_projection" | localize }}</button>
        </div>
      </div>

      <kpi-time-filters [kpiId]="kpi.id"></kpi-time-filters>

      <kpi-chart #kpiChart (commentAdd)="addCommentHandler($event)"></kpi-chart>

      <kpi-statistics-list></kpi-statistics-list>
    </div>
    <onboarding
      *ngIf="onboarding && onboarding.shouldShow"
      [delegate]="onboarding.delegate"
      [steps]="onboarding.totalSteps"
      [startFromStep]="onboarding.startingStep"
      [class.with-kpi-description]="(kpi$ | async).description"
      section="kpis"
      popoverTitle="kpi_detail_and_projections"
      description="kpi_detail_and_projections_description"></onboarding>
    <div *ngIf="kpiCommentsOnboardingAvailable$ | async">
      <onboarding
        *ngIf="commentsOnboarding && commentsOnboarding.shouldShow"
        [delegate]="commentsOnboarding.delegate"
        [steps]="1"
        [startFromStep]="1"
        [hidePrimaryButton]="true"
        [hideSteps]="true"
        popoverTitle="kpi_comments"
        description="kpi_comments_description"
        section="kpiComments"></onboarding>
    </div>
  </ng-container>

  <ng-container *ngIf="error$ | async as error">
    <div class="error-wrapper">
      <i class="error-icon" ui-icon uiType="attention" uiTheme="fill"></i>
      <div class="error-title">{{ error.title }}</div>
      <div class="error-message">{{ error.message }}</div>
    </div>
  </ng-container>

  <kpi-details-skeleton *ngIf="isLoading$ | async"></kpi-details-skeleton>
</div>

<ng-template [uiDrawerTitle]>
  <div class="kpi-details-title-skeleton" *ngIf="isLoading$ | async">
    <ui-skeleton [uiTitle]="{ width: '620px' }" [uiSectionHeight]="{ title: 'h-md', paragraph: 'h-sm' }" [uiParagraph]="false" [uiActive]="true"></ui-skeleton>
  </div>

  <div class="kpi-details-title" *ngIf="(isLoading$ | async) === false && (error$ | async) === null && kpi$ | async as kpi">
    <i class="fs-16px" ui-icon uiTheme="fill" uiType="kpi"></i>
    <h3 [uiTooltipTitle]="kpi.name" tooltipIfOverflow="hover" uiTooltipPlacement="bottom" data-test-id="kpi-details-name-field" ui-tooltip>{{ kpi.name }}</h3>
  </div>
</ng-template>

<ng-template [uiDrawerExtra]>
  <div class="kpi-details-title-skeleton" *ngIf="isLoading$ | async">
    <ui-skeleton-element *ngFor="let i of [1, 2]" [uiActive]="true" uiSize="small" uiType="avatar"></ui-skeleton-element>
  </div>

  <div class="kpi-details-actions" *ngIf="(isLoading$ | async) === false && (error$ | async) === null && kpi$ | async as kpi">
    <a
      [disabled]="(kpiHasNoSnapshotsAndProjections$ | async) === true"
      [uiTooltipArrowPointAtCenter]="true"
      [uiTooltipTrigger]="(kpiHasNoSnapshotsAndProjections$ | async) === true ? 'hover' : null"
      [uiTooltipTitle]="'update_kpi_or_add_projection_to_comment' | localize"
      [a11yTitle]="'update_kpi_or_add_projection_to_comment' | localize"
      (click)="hideAddFirstCommentView()"
      uiSref=".comments"
      uiSrefActive="selected"
      ui-button
      uiType="link"
      ui-tooltip
      uiTooltipPlacement="bottomRight"
      data-test-id="kpi-details-comments-button"
      ><i ui-icon uiType="comments"></i
    ></a>
    <gh-dropdown [menuItems]="kpiDetailsMenuItems" dropdownMenuClass="kpi-details-menu" iconName="menu-horizontal"></gh-dropdown>
  </div>
</ng-template>

<ng-template [uiDrawerSidePanel]>
  <div class="kpi-comments-portal" ui-view>
    <add-first-comment
      *ngIf="(addFirstCommentToPointContext$ | async).inProgress"
      [kpi]="kpi$ | async"
      [commentData]="chartPointCommentData"
      [cdkTrapFocusAutoCapture]="true"
      cdkTrapFocus></add-first-comment>
  </div>
</ng-template>
